import { Clock, DoorOpen } from "@phosphor-icons/react";
import { TZ_ABBR, fmtClock } from "@/lib/api";

export const Agenda = ({ agenda, doorsOpen, tz, compact = false }) => {
  const z = TZ_ABBR[tz] || "";
  return (
    <div data-testid="event-agenda">
      {doorsOpen && <div className="mb-2 flex items-center gap-2 text-sm font-semibold" data-testid="agenda-doors"><DoorOpen size={18} className="text-[#E0A21B]" /> Doors and check-in open at {fmtClock(doorsOpen)} {z}</div>}
      <div className="divide-y">
        {agenda.map((a) => (
          <div key={a.start} className={`flex flex-wrap items-center justify-between gap-2 ${compact ? "py-1.5 text-sm" : "py-3"}`} data-testid={`agenda-item-${a.start}`}>
            <span className={a.title.startsWith("Session") ? "font-semibold" : "text-[#475569]"}>{a.title}</span>
            <span className="flex items-center gap-1.5 text-sm text-[#475569]"><Clock size={16} />{fmtClock(a.start)} – {fmtClock(a.end)} {z}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
